export const AMEND_LOAN_REQUESTS_START = 'AMEND_LOAN_REQUESTS_START';
export const AMEND_LOAN_REQUESTS_SUCCESS =
  'AMEND_LOAN_REQUESTS_SUCCESS';
export const AMEND_LOAN_REQUESTS_ERROR = 'AMEND_LOAN_REQUESTS_ERROR';
export const AMEND_LOAN_REQUESTS_END = 'AMEND_LOAN_REQUESTS_END';
